/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveWaffle } from '@nivo/waffle';

import customTooltip from '../../utils/chartTools/handleCustomTooltip';
import colorSelector from '../../utils/formatCharts/handleColor';
import { genData1D } from '../../utils/formatCharts/handleData';
import KpiStatus from '../../utils/chartTools/KpiStatus';

const emptyObj = {};

const Waffle = ({
  data, styleConfig, globalConfig = emptyObj,
}) => {
  const [chartData, setChartData] = useState({ ready: false });

  useEffect(() => {
    setChartData(genData1D(data, styleConfig));
  }, [
    data,
    styleConfig.DataFormat,
    styleConfig.DataPercentFormat,
    styleConfig.DataFormatAlt,
    styleConfig.DataPercentFormatAlt,
    styleConfig.DataAbsoluteFormatAlt,
    styleConfig?.InvertVariation,
    ...styleConfig.CustomSortControl.kpiCategories,
    styleConfig.SortValuesControl,
  ]);

  const createTooltip = (val) => customTooltip(val.data, 'waffle', styleConfig);

  return chartData.ready && data?.index?.[0] !== 'Totais' ? (
    <KpiStatus
      conditions={([
        [
          'NoLineSelected',
          data?.index?.[0] === 'Totais',
        ],
      ])}
    >
      <ResponsiveWaffle
        data={chartData.data}
        total={chartData.total}
        /* General */
        rows={+(styleConfig?.RowsControl || 15)}
        columns={+(styleConfig?.ColumnsControl || 10)}
        margin={styleConfig?.Margin || {
          top: 40, right: 60, bottom: 40, left: 60,
        }}
        fillDirection={styleConfig?.FillDirection}
        padding={+(styleConfig?.PaddingControl?.value)}
        /* Style */
        borderWidth={+(styleConfig?.BorderWidthControl?.value || 0)}
        borderColor={styleConfig.BorderColorControl ? styleConfig.BorderColorControl : {
          from: 'color', modifiers: [['darker', 1.6]],
        }}
        colors={colorSelector({
          dataLength: chartData.data?.length,
          config: styleConfig,
          colorKey: 'id',
          globalConfig,
        })}
        /* Legend */
        legends={styleConfig?.LegendControl?.checked ? [{
          ...styleConfig?.LegendPlacementControl?.value,
          itemWidth: 100,
          itemHeight: 18,
          symbolSize: 18,
          symbolShape: styleConfig?.LegendSymbolControl || 'circle',
          itemsSpacing: parseInt(styleConfig?.LegendsSpacingControl?.value, 10),
          justify: false,
          effects: [{
            on: 'hover',
            style: {
              itemTextColor: '#000',
            },
          }],
        }] : []}
        /* Tooltip */
        isInteractive={!!styleConfig?.InteractiveControl}
        tooltip={createTooltip}
        /* Extra theme */
        theme={{
          legends: {
            text: {
              fontSize: `${styleConfig?.LegendsFontSizeControl?.value}px`,
              fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontLegend : styleConfig?.LegendsFontFamilyControl?.value}', Arial`,
              fill: styleConfig?.LegendFontColor ?? '#999',
              fontWeight: styleConfig?.LegendBold ? 'bold' : 'normal',
              fontStyle: styleConfig?.LegendItalic ? 'italic' : 'normal',
            },
            hidden: {
              text: {
                textDecoration: 'line-through',
              },
            },
          },
        }}
        /* Static */
        animate={false}
        motionStiffness={90}
        motionDamping={15}
        emptyOpacity={0}
      />
    </KpiStatus>
  ) : <></>;
};

Waffle.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  styleConfig: PropTypes.objectOf(PropTypes.any).isRequired,
  globalConfig: PropTypes.objectOf(PropTypes.any),
};

export default Waffle;
